import React, { useEffect, useState } from "react";
import DynamicTable from "../../../Components/InputComponents/LookupView";
import { Edit, Delete, Visibility } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { axiosAPI } from "../../../Components/AxiosComponents/Axios";
import { encryptId } from "../../../Components/CryptoComponent";
import { useStaffLayout } from "../../../Components/Context/CandidateLayoutContext";

function DepartmentList({ isAdmin }) {
  const navigate = useNavigate();

  const { privilegeData } = useStaffLayout();

  function hasdepartAddprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("department");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hasdepartEditprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("department");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  const columns = [
    { field: "DL_Id", label: "#" },
    { field: "DL_Name", label: "Department" },
    { field: "DL_Status", label: "Status" },
  ];

  const [searchParams] = useSearchParams();

  const actions = [
    hasdepartEditprivilege(privilegeData) && {
      icon: Edit,
      handler: (row) => {
        const encrypted = encodeURIComponent(encryptId(row?.DL_Id));

        navigate(
          `/DepartmentLookup/Edit/${encrypted}?${searchParams.toString()}`
        );
      },
      color: "warning",
    },
  ].filter(Boolean);
  
  return (
    <DynamicTable
      columns={columns}
      dataAPI={`/Department/list`}
      actions={actions}
      title={`Department`}
      {...(hasdepartAddprivilege(privilegeData) && {
        linkvalue: `/DepartmentLookup/Add?${searchParams.toString()}`,
      })}
    />
  );
}

export default DepartmentList;
